import SVG from "../SVG";
import { useState } from "react";
import PassStrength from "./PassStrength";

export default function PassWord({
  placeholder = "",
  id = "",
  passwordBlur,
  setPasswordBlur,
  passwordValid,
  formValue,
  formOnChange,
  hasPassStrength = false,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const hasValue =
    formValue !== undefined && formValue !== null && String(formValue).length > 0;
  const isLabelActive = isFocused || hasValue;

  const handleToggle = () => {
    setShowPassword(!showPassword);
  };

  const strengthId = `${id || "password"}-strength`;

  return (
    <div className="w-full">
      <div
        style={
          passwordBlur && !passwordValid
            ? { border: "0.5px solid #fbbf24" }
            : null
        }
        className="relative w-full h-[42px] border bg-transparent dark:bg-zi-inputbg-dark border-zi-border-light dark:border-none rounded-lg flex items-center justify-between overflow-visible hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-dark/50 gap-1"
      >
        <input
          type={showPassword ? "text" : "password"}
          id={id}
          placeholder=""
          className="zi-input-autofill text-sm w-full min-w-0 h-full px-3 outline-none bg-transparent text-zi-text-light dark:text-zi-text-dark [direction:ltr] text-start"
          value={formValue}
          onChange={formOnChange}
          aria-describedby={hasPassStrength ? strengthId : undefined}
          onFocus={() => {
            setIsFocused(true);
            if (!setPasswordBlur) return;
            setPasswordBlur(false);
          }}
          onBlur={() => {
            setIsFocused(false);
            if (!setPasswordBlur) return;
            setPasswordBlur(true);
          }}
        />
        {placeholder && (
          <label
            htmlFor={id}
            className={`zi-floating-label pointer-events-none absolute right-2 z-10 origin-right px-1 leading-none transition-all duration-200 ease-in-out ${
              isLabelActive
                ? "top-0 -translate-y-1/2 text-xs text-zi-blue-light dark:text-zi-text-dark dark:bg-zi-inputbg-dark rounded-lg px-2.5 py-1"
                : "top-1/2 -translate-y-1/2 text-sm text-zi-text-light/50 dark:text-zi-text-dark/50 "
            }`}
          >
            {placeholder}
          </label>
        )}

        <button
          type="button"
          tabIndex="-1"
          onClick={handleToggle}
          className="relative z-20 p-2"
        >
          <SVG
            name={showPassword ? "eye" : "eyeClosed"}
            classname={
              showPassword
                ? "stroke-zi-blue-dark dark:stroke-white"
                : "fill-zi-blue-dark dark:fill-white"
            }
          />
        </button>

        <style>
          {`
            input[type="password"]::-ms-reveal,
            input[type="password"]::-ms-clear {
              display: none !important;
            }
          `}
        </style>
      </div>

      {hasPassStrength && (
        <PassStrength
          password={formValue ?? ""}
          id={strengthId}
          showValidationErrors={passwordBlur && hasValue && !isFocused}
        />
      )}
    </div>
  );
}
